<mat-card class="notification-detail">
  <div class="main-content">
    <div class="info-block">
      <div class="header">
        <mat-card-title class="title">{{ data.title || 'Notification' }}</mat-card-title>
      </div>
      <mat-card-content class="body">
        <div class="text-body">
          <p [innerHtml]="data.htmlBody"></p>
        </div>
      </mat-card-content>
      <div class="version-date">
        <span class="date">{{ data.activeUntil | customDate: 'dd MMMM yyyy' }}</span>
        <span class="dot" *ngIf="data.notificationType">●</span>
        <span class="version">{{ data.notificationType }}</span>
      </div>
    </div>
  </div>
  <mat-card-actions class="actions">
    <button mat-stroked-button (click)="close()">{{ 'back' | translate }}</button>
    <a class="release-notes-button" mat-button mat-dialog-close href="http://updates.goodxcloud.co.za/#mygcapp" target="_blank">
      <mat-icon>description</mat-icon>
      {{ 'release_notes' | translate }}
    </a>
  </mat-card-actions>
</mat-card>
